exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".com-point-label__text[data-v-2e333e01]{font-size:14px;font-weight:400;color:#262626;line-height:20px}.com-point-label .ellipsis[data-v-2e333e01]{max-width:112px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;word-wrap:normal;word-break:normal}\n", ""]);

